export const noop = (): void => {};

export {
  dayInTz,
  formatBucketChartLabel,
  formatDateTimeInTz,
  formatDateTimeTriple,
  formatTimezoneDetail,
  formatTimezoneLabel,
  formatTimezoneShort,
  getViewerTimezone,
  todayInTz,
} from "./datetime.ts";

/** 奖品候选条目（与 packages/domain 的 PrizeCandidate 同构，供 Admin 前端使用）。 */
export interface PrizeCandidate {
  readonly id: string;
  readonly weight: number;
  readonly isExhausted: boolean;
  readonly type: string;
}

/**
 * 按 weight 计算各奖品中奖概率。isExhausted=true 或 weight<=0 的奖品概率为 0。
 * 与 packages/domain/src/lottery/probability.ts computeProbabilities 逻辑一致。
 */
export const computeProbabilities = (
  prizes: ReadonlyArray<PrizeCandidate>,
): Map<string, number> => {
  const usable = prizes.filter((p) => p.weight > 0 && !p.isExhausted);
  const total = usable.reduce((s, p) => s + p.weight, 0);
  const result = new Map<string, number>();
  for (const p of prizes) {
    if (p.weight <= 0 || p.isExhausted || total === 0) result.set(p.id, 0);
    else result.set(p.id, p.weight / total);
  }
  return result;
};
